import { useState } from "react";
import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import RefrigerationTable from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import "./index.css";
import refrigerationIcon from "../../../../../assets/design-revamp-company/category-icons/refrigeration_icon.svg";
const RefrigerationContents = ({ businessId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable] = useState(false);
  return (
    <div className="emission-gas-contents">
      <div style={{ display: "flex", alignItems: "center" }}>
        <SubHeaderBox
          subTitle={t("REFRIGERATION_INPUTS")}
          isNormal={true}
          number={"3.1"}
          icon={refrigerationIcon}
        />
      </div>
      {showTable && <RefrigerationTable businessId={businessId} />}
      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default RefrigerationContents;
